module.exports = __webpack_public_path__ + "static/scale-model-of-cathedral-basilica-of-st.-joseph-in-san-jose-california-635e0d3cd351e5b5764b67e6e33a214d.png";